import React from 'react';
import { Alert, Space, Image } from 'tdesign-react';
import xhsQrCodeExample from '../public/xhs_qr_example.svg'; // Assuming you have this image, if not, you'll need to add it

const AccountTable = ({
    tasks,
    taskId,
    marketingScript,
    setIsStartAble,
    progress,
    curMarketingTaskId,
    setCurMarketingTaskId,
    options
}) => {
    return (
        <div style={{ width: '100%', padding: '20px' }}>
            <Alert
                theme="info"
                title="小红书暂不支持电脑端私信"
                message={
                    <Space direction="vertical" size="large" style={{ width: '100%', padding: '10px 0' }}>
                        <p>请使用手机扫描二维码进行私信（鼠标移动到昵称上会显示二维码）</p>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <Image 
                                src={xhsQrCodeExample} 
                                alt="小红书二维码示例" 
                                style={{ width: '200px', height: 'auto' }}
                            />
                        </div>
                        <p style={{ fontSize: '14px', color: '#666', textAlign: 'center' }}>示例：鼠标悬停在昵称上时会显示类似上方的二维码</p>
                    </Space>
                }
                style={{ width: '100%' }}
            />
        </div>
    );
};

export default AccountTable;
